import React, { useState } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  InputAdornment,
  IconButton,
} from "@mui/material";
import { useFormik } from "formik";
import { useNavigate, useSearchParams } from "react-router-dom";
import TagMeetingHeader from "../components/TagMeetingHeader";
import { axiosInstance } from "../service/axiosInstance";
import { toast } from "sonner";
import { resetSchema } from "../utils/validation";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import serviceEndpoints from "../services/serviceEndpoints";

const ResetPassword = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [search] = useSearchParams();
  const token = decodeURIComponent(search.get("token"));
  const [showPassword, setShowPassword] = useState(false);

  const { values, handleChange, handleSubmit, errors, touched } = useFormik({
    initialValues: { password: "", confirmPassword: "" },
    onSubmit: (values) => handleResetPassword(values),
    validationSchema: resetSchema,
  });

  async function handleResetPassword(value) {
    setLoading(true);
    try {
      await axiosInstance.post(
        serviceEndpoints.resetPasswordEndpoints,
        {
          password: value.password,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toast.success("Reset password successfully");
      navigate("/");
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  }

  const handleShowPasswordClick = () => {
    setShowPassword(!showPassword);
  };

  return (
    <>
      <TagMeetingHeader headerName="Reset Password" />
      <div className="container d-flex justify-content-center align-items-center vh-100">
        <Box
          sx={{
            width: "100%",
            maxWidth: 360,
          }}
        >
          <form onSubmit={handleSubmit}>
            <TextField
              fullWidth
              id="password"
              name="password"
              type={showPassword ? "text" : "password"}
              label="New Password"
              variant="outlined"
              value={values.password}
              onChange={handleChange}
              error={touched.password && errors.password}
              helperText={touched.password && errors.password}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={handleShowPasswordClick}>
                      {showPassword ? (
                        <VisibilityOff sx={{ fontSize: "1.5rem !important" }} />
                      ) : (
                        <Visibility sx={{ fontSize: "1.5rem !important" }} />
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              sx={{ mb: 2 }}
            />
            <TextField
              label="Confirm Password"
              type={showPassword ? "text" : "password"}
              value={values.confirmPassword}
              onChange={handleChange}
              name="confirmPassword"
              fullWidth
              sx={{ mb: 2 }}
              required
              error={touched.confirmPassword && !!errors.confirmPassword}
              helperText={touched.confirmPassword && errors.confirmPassword}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={handleShowPasswordClick}>
                      {showPassword ? (
                        <VisibilityOff sx={{ fontSize: "1.5rem !important" }} />
                      ) : (
                        <Visibility sx={{ fontSize: "1.5rem !important" }} />
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />

            <Typography
              variant="body2"
              sx={{ color: "#030303ff;", textAlign: "right" }}
              onClick={() => navigate("/")}
            >
              Login?
            </Typography>
            <Button
              fullWidth
              type="submit"
              variant="contained"
              sx={{
                borderRadius: "25px",
                textTransform: "none",
                fontSize: "16px",
                mt: 2,
              }}
              disabled={loading}
            >
              Submit
            </Button>
          </form>
        </Box>
      </div>
    </>
  );
};

export default ResetPassword;
